import Show from 'src/pages/ProductInstances/Show.vue'

const auth = { requiresAuth: true }
const saveFrom = { saveFrom: true }
const notUser = { requiresNotUser: true }

export default [
  {
    path: '/product_instances/:id',
    name: 'Produkt Instanz',
    component: Show,
    meta: { ...auth, ...notUser, ...saveFrom }
  }
]
